import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Doctor } from "@/features/modules/doctor/objects/Doctor";
import { doctorModel } from "@/features/modules/doctor/models/DoctorModel";
import { EmployeeDuty } from "@/features/modules/employeeDuty/objects/EmployeeDuty";
import { employeeDutyModel } from "../EmployeeDutyModel";
import { offlineModel } from "@/core/modules/offline/models/OfflineModel";
import { store } from "@/core/modules/store/module";
import { storeTypes } from "@/core/modules/store/types";
import { User } from "@/core/modules/user/objects/User";

export const getEmployeeDutiesByCompany = async (companyId: string): Promise<EmployeeDuty[]> => {
  try {
    const user: User = store.getters[storeTypes.getters.getUser];

    if (offlineModel.getOfflineState() === "offline") {
      if (employeeDutyModel.offlineModuleModel === undefined) return [];
      if (user.canRead("offline") === false) throw new Error("user doesn't have offline rights");

      const documents: EmployeeDuty[] = (await offlineModel.getCacheByCollection(employeeDutyModel.offlineModuleModel)) as EmployeeDuty[];
      return documents.filter((employeeDuty) => employeeDuty.parentId === companyId);
    }

    if (user.role?.name === "Medico") {
      const doctor: Doctor | undefined = await doctorModel.getDoctorFromUser(user.id);
      if (doctor === undefined || doctor.authorizedCompaniesIds.includes(companyId) === false)
        throw new Error(`User doesn't have rights to read company #${companyId}`);
    }

    const snapshotQuery: Query<EmployeeDuty> = query(
      employeeDutyModel.getGroupPathReference().withConverter(employeeDutyModel.firestoreConverter),
      where("company.id", "==", companyId)
    );

    const snapshot: QuerySnapshot<EmployeeDuty> = await getDocs(employeeDutyModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return [];

    return snapshot.docs.map((doc) => {
      const employeeDuty: EmployeeDuty = doc.data();
      employeeDuty.parentId = doc.ref.parent.parent?.id;
      return employeeDuty;
    });
  } catch (error: unknown) {
    appFaultModel.catchAppError("EmployeeDutyModel.getEmployeeDutiesByCompany", { companyId }, error);
    return [];
  }
};
